import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import { cn } from '@src/design-system/helpers';
import { Check } from 'lucide-react';
import type { ReactNode } from 'react';

export const ItemInfo = <T,>({
  id,
  name,
  avatar,
  description,

  isSelected,
  withAvatar,
  withCheckbox,
  item,

  onClick,
  renderExtraElementInside,
  renderExtraElementOutside,

  className,
}: {
  id: number;
  name: string;
  description?: string;
  avatar?: string;

  withCheckbox?: boolean;
  withAvatar?: boolean;
  isSelected?: boolean;
  item: T;

  renderExtraElementInside?: (item: T) => ReactNode;
  renderExtraElementOutside?: (item: T) => ReactNode;
  onClick: () => void;

  className?: string;
}) => {
  return (
    <div className='relative group'>
      <div
        onClick={onClick}
        className={cn(
          'z-10 flex border border-pale-border text-sm text-start w-full p-2 hover:bg-primary-30 rounded-lg gap-2 items-center cursor-pointer',
          isSelected && 'bg-primary-50 border-primary-400 hover:bg-primary-50',
          className
        )}
      >
        <div className='flex items-center w-full justify-between'>
          <div className='flex items-center min-w-0 gap-2'>
            {withAvatar && (
              <Avatar className='size-10'>
                <AvatarImage src={avatar} />
                <AvatarFallback colorId={id}>{name[0]}</AvatarFallback>
              </Avatar>
            )}
            <div className='flex min-w-0 flex-col'>
              {name && <span className='text-gray-900'>{name}</span>}

              {description && (
                <span className='text-xs text-gray-500 truncate min-w-0'>
                  {description}
                </span>
              )}
            </div>
          </div>

          {renderExtraElementInside?.(item)}

          {withCheckbox && (
            <div
              className={cn(
                'size-4 border flex justify-center items-center  rounded-sm border-active-border',
                isSelected && 'bg-primary-1000'
              )}
            >
              <Check
                strokeWidth={3}
                className='h-4 w-4 text-white'
              />
            </div>
          )}
        </div>
      </div>

      {renderExtraElementOutside?.(item)}
    </div>
  );
};
